// frontend/src/ConfigSection.js
import React, { useState } from 'react';
import './App.css'; // Reuse styles
import DataView from './DataView'; // Import the first config page
import DataReview from './DataReview'; // Import the DataReview page
import SettingsPage from './SettingsPage'; // Import the Settings page

function ConfigSection({
    isAuthenticated,
    directories,
    navigateToExplorer, // Function to go back
    isLoading: isAppLoading, // Rename parent loading state to avoid conflict
    setIsLoading: setAppIsLoading, // Rename parent setter
    error: appError, // Rename parent error state
    setError: setAppError, // Rename parent setter
    handleLogout, // Pass down for API calls within pages
    theme,      // <<< NEW: Accept theme state
    setTheme    // <<< NEW: Accept theme setter function
}) {
    const [activeTab, setActiveTab] = useState('dataView'); // 'dataView', 'dataReview', 'settings'

    const renderActiveTab = () => {
        switch (activeTab) {
            case 'dataView':
                return <DataView
                            directories={directories}
                            handleLogout={handleLogout}
                       />;
            case 'dataReview':
                return <DataReview handleLogout={handleLogout} />;
            case 'settings':
                 // <<< MODIFIED: Pass theme and setTheme props to SettingsPage >>>
                return <SettingsPage 
                            handleLogout={handleLogout} 
                            theme={theme}
                            setTheme={setTheme}
                       />;
            default:
                return <DataView directories={directories} handleLogout={handleLogout} />;
        }
    };

    return (
        <div className="config-section-container">
            <div className="config-tabs">
                <button
                    className={`config-tab ${activeTab === 'dataView' ? 'active' : ''}`}
                    onClick={() => setActiveTab('dataView')}
                    disabled={isAppLoading}
                >
                    Data View
                </button>
                <button
                    className={`config-tab ${activeTab === 'dataReview' ? 'active' : ''}`}
                    onClick={() => setActiveTab('dataReview')}
                    disabled={isAppLoading}
                >
                    Data Review
                </button>
                <button
                    className={`config-tab ${activeTab === 'settings' ? 'active' : ''}`}
                    onClick={() => setActiveTab('settings')}
                    disabled={isAppLoading}
                >
                    Settings
                </button>
            </div>
            <div className="config-page-area">
                 {renderActiveTab()}
            </div>
        </div>
    );
}

export default ConfigSection;
